<template>
  <v-dialog v-model="dialog" max-width="800px">
    <template v-slot:activator="{ on }">
      <mf-button :disabled="disabled" text color="marca-0-l40" icon="forward_to_inbox" label="Exportar ofertas" class="mx-2" v-on:click.native="on.click" />
    </template>
    <v-card v-if="dialog">
      <div class="pa-4">
        <h1 class="section-title">Exportar ofertas</h1>
      </div>
      <v-card-text class="pa-0">
        <v-row no-gutters class="px-4">
          <v-col cols="6">
            <v-radio-group v-model="exportMode" :disabled="loading" class="pt-0 mt-0">
              <v-radio label="Ofertas ativas no período" color="primary" value="active" />
              <v-radio label="Ofertas que iniciam no período" color="primary" value="started" />
              <v-radio label="Ofertas que encerram no período" color="primary" value="ended" />
            </v-radio-group>
          </v-col>
          <v-col cols="6">
            <div class="pt-1">
              <mf-date-range-picker
                :label="dateRangePickerLabel"
                :initial-date.sync="initialDate"
                :final-date.sync="endDate"
                :disabled="loading"
                :error-messages="errorMessages"
                :error="!!errorMessages"
                outlined
                icon
                dense
                :max="maxDate"
              />
            </div>
          </v-col>
        </v-row>
        <include-emails-table ref="includeEmailsTable" :emails.sync="emails" :max-emails-to-scroll="4" scroll-height="192px" />
      </v-card-text>
      <v-card-actions class="d-flex justify-end mr-2">
        <mf-button text label="Cancelar" class="mr-3" @click="dialog = false" />
        <export-data async :loading="loading" @file-format="getFileFormat" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { MUTATION_RESEND_ASYNC_JOB } from '../../graphql'
import { DateTime } from 'luxon'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ExportAllSalesModal',
  components: {
    ExportData: () => import('@/components/export-data/ExportData.vue'),
    IncludeEmailsTable: () => import('@/components/export-email-report/IncludeEmailsTable.vue'),
  },
  data: () => ({
    dialog: false,
    disabled: false,
    loading: false,
    initialDate: null,
    endDate: null,
    exportMode: 'active',
    fileFormat: 'CSV',
    emails: [],
  }),
  computed: {
    dateRangePickerLabel() {
      const exportModeToDatePickerLabel = {
        active: 'Ofertas ativas no período',
        started: 'Ofertas que iniciam no período',
        ended: 'Ofertas que encerram no período',
      }
      return exportModeToDatePickerLabel[this.exportMode]
    },
    getDates() {
      const startDate = `${this.initialDate}T00:00:00-03:00`
      const endDate = `${this.endDate}T23:59:59-03:00`
      if (this.exportMode === 'active') {
        return { activeAt: { startDate, endDate } }
      } else if (this.exportMode === 'started') {
        return { startedAt: { startDate, endDate } }
      } else return { endedAt: { startDate, endDate } }
    },
    maxDate() {
      if (!this.initialDate) return ''
      return DateTime.fromISO(this.initialDate).plus({ days: +6 }).toFormat('yyyy-MM-dd')
    },
    errorMessages() {
      if (this.$v.initialDate.$error || this.$v.endDate.$error) {
        return 'Selecione uma data de envio.'
      }
      return ''
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.$v.$reset()
        this.emails = []
        this.initialDate = null
        this.endDate = null
        this.exportMode = 'active'
      }
    },
  },
  methods: {
    getFileFormat(value) {
      this.fileFormat = value
      this.validateFields()
    },
    validateFields() {
      this.$v.$reset()
      this.$v.$touch()

      const isValid = this.$refs.includeEmailsTable.isValid()
      if (this.$v.$error || !isValid) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente.', snackbarColor: 'error' })
        return
      }
      this.sendReport()
    },
    async sendReport() {
      const variables = {
        ...this.getDates,
        emails: this.emails,
        fileFormat: this.fileFormat.toUpperCase(),
      }

      try {
        await this.$apollo.mutate({
          mutation: MUTATION_RESEND_ASYNC_JOB,
          variables,
          context: {
            uri: this.$microservicesUrls['asyncJobs'],
          },
        })
        this.$snackbar({ message: 'E-mail enviado com sucesso', snackbarColor: 'success' })
        this.dialog = false
      } catch (error) {
        console.log(error)
        this.$snackbar({ message: 'Ocorreu um erro ao reenviar o relatório.', snackbarColor: 'error' })
      }
    },
  },
  validations() {
    return {
      initialDate: {
        required,
      },
      endDate: {
        required,
      },
    }
  },
}
</script>
